import { Injectable } from '@angular/core';
import { SharedDataService } from '../../../shared-data.service';

export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  children?: ChildrenItems[];
}
let shareddata : SharedDataService;
const MENUITEMS = [
  // {
  //   state: 'whats-new',
  //   name: ' Whats New ',
  //   type: 'link',
  //   icon: 'icon-star icons'
  // },
  {
    state: 'home',
    name: ' Home ',
    type: 'link',
    icon: 'icon-home icons'
  },
  {
    state: 'financial-management',
    name: 'Financial Management',
    type: 'link',
    icon: 'icon-wallet icons',
  },
  {
    state: 'notification',
    name: 'Notification',
    type: 'link',
    icon: 'glyphicon glyphicon-bullhorn'
  },
  {
    state: 'report-management',
    name: 'Report Management',
    type: 'link',
    icon: 'icon-docs icons',
  },
  {
    state: 'classroom-management',
    name: 'Classroom Management',
    type: 'link',
    icon: 'icon-home icons',
  }
  ,
  {
    state: 'student-management',
    name: 'Student Management',
    type: 'link',
    icon: 'icon-user icons',
  },
  {
    state: 'staff-teacher-management',
    name: 'Staff/Teacher Management',
    type: 'link',
    icon: 'icon-user icons',
  },   
  // {
  //   state: 'course-management',
  //   name: 'Course Management',
  //   type: 'link',
  //   icon: 'icon-docs icons',
  // },

  // {
  //   state: 'non-academic-management',
  //   name: 'Non Academic Management',
  //   type: 'link',
  //   icon: 'icon-action-redo icons',
  // }

];

let MENUITEMS2 = [];
    
@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    return MENUITEMS;
  }
  add(menu: Menu) {
    MENUITEMS.push(menu);
  }

  setVars(rname){
    let counter = 0;
    if (rname.toLowerCase() == 'sims admin') {
      // MENUITEMS2 = MENUITEMS;
      MENUITEMS2 = MENUITEMS;
    } 
    else if (rname.toLowerCase() == 'teacher') {
      MENUITEMS2 = [
        {
          state: 'home',
          name: ' Home ',
          type: 'link',
          icon: 'icon-home icons'
        },
        {
          state: 'report-management',
          name: 'Report Management',
          type: 'link',
          icon: 'icon-docs icons',
        },
        {
          state: 'classroom-management',
          name: 'Classroom Management',
          type: 'link',
          icon: 'icon-home icons',
        }
      ];        
    }
    else{
      MENUITEMS2 = [
        {
          state: 'home',
          name: ' Home ',
          type: 'link',
          icon: 'icon-home icons'
        }
      ];
    }
  }

};



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/core/menu/menu-items/menu-items.ts